// extracted by mini-css-extract-plugin
export default {"loader-overlay":"loaderWithOverlay_loader-overlay__+Eaax"};